import type { SelectOption } from "core/entities";
import { useCentrixApi } from "core/hooks/useCentrixApi";
import { useRegion } from "core/hooks/useRegion";
import { useMemo } from "react";

export function useInsurerSelectOptions() {
  const { data, isLoading, isError } = useCentrixApi({
    path: "/api/shared-entities/partners/public",
    parameters: {
      query: {
        IsPaymentRequestEnabled: true,
        CountryCode: useRegion(),
      },
    },
    fetchAll: true,
  });

  const insurersOptions = useMemo(
    () =>
      data?.items
        ?.sort((a, b) => {
          if (!a.name || !b.name) {
            return 0;
          }
          return a.name > b.name ? 1 : -1;
        })
        .map(({ id, name }) => ({ value: id, label: name ?? id }))
        .filter(
          (entry): entry is SelectOption =>
            typeof entry.label === "string" && typeof entry.value === "string"
        ) ?? [],
    [data]
  );
  return { insurersOptions, isLoading, isError, data };
}
